import * as React from 'react'
// import * as ReactDom from 'react-dom'
// import { Main } from '../../../Logic/Main'
// import { Logic } from '../../../Logic/Type'
import Socket from '../../../Socket/socket-init'
import * as Assets from '../../../assets/Assets'
import * as RouteClasses from '../../../Socket/route-classes'
import * as Body from '../../../Views/Main/Index/Body'
import { Link } from 'react-router-dom'

interface IProps {
}

interface IState {
    email: string
    username: string
    password: string
    passwordConfirmation: string
    mobileMenu: boolean
    checkbox: boolean
    subscription: boolean
}

export default class SignUp extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)

        window.scroll(0, 0)

        window.onload = () => {
            Socket.Send('flags', {})
        }

        this.state = this.getInitialState()

        this.handleSubmit = this.handleSubmit.bind(this)

        Socket.Send('flags', {})
    }

    getInitialState() {
        return {
            email: '',
            username: '',
            password: '',
            passwordConfirmation: '',
            mobileMenu: false,
            checkbox: false,
            subscription: false
        }
    }

    handleInput(value: string, state: string) {
        this.state[state] = value
        this.setState(this.state)
    }

    handleSubmit(event) {
        event.preventDefault()
        if (this.state.email === '') {
            alert('Write your Email.')
        } else if (this.state.username === '') {
            alert('Write your Username.')
        } else if (this.state.password === '') {
            alert('Write your Password.')
        } else if (!this.state.checkbox) {
            alert('You have to agree to the Accumulator Club Terms of Service.')
        } else {
            if (this.state.password === this.state.passwordConfirmation) {
                const user: RouteClasses.IUser = {
                    firstName: '',
                    lastName: '',
                    email: this.state.email,
                    username: this.state.username,
                    password: this.state.password,
                    nationality: '',
                    subscription: this.state.subscription
                }
                Socket.Send('registration', user)
            }
        }
    }

    componentWillUnmount() {
        Socket.Set('registration', {})
    }

    render() {
        const registration = Socket.Get<any>('registration')
        return (
            <section className="wrapper">
                <div className="navigation-main-wrapper">
                    <div className="navigation-main navbar navbar-default" style={{ marginBottom: '0' }}>
                        <div className="container">
                            <div className="row">
                                <Link className="navbar-brand" to="/">
                                    <img src="logo-main2.png" alt="" className="logo logo-acc" />
                                </Link>
                                <button
                                    onClick={() => this.setState({ mobileMenu: !this.state.mobileMenu })}
                                    type="button"
                                    className={(this.state.mobileMenu) ? 'navbar-toggle navbar-mid-toggle' : 'navbar-toggle navbar-mid-toggle collapsed'}
                                    data-toggle="collapse"
                                    data-target="#navbar-collapse-mid"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                >
                                    <span className="sr-only">Toggle navigation</span>
                                    <span className="icon-bar" />
                                    <span className="icon-bar" />
                                    <span className="icon-bar" />
                                </button>
                                <div className="clearfix" />
                                <nav
                                    className={(this.state.mobileMenu) ? 'collapse navbar-collapse navbar-mid-bar collapse in' : 'collapse navbar-collapse navbar-mid-bar'}
                                    id="navbar-collapse-mid"
                                    aria-expanded={(this.state.mobileMenu) ? 'true' : 'false'}
                                    style={(this.state.mobileMenu) ? { height: '220px' } : { height: '1px' }}
                                >
                                    {Body.getMenu('pull-left', Assets.menuLeft)}
                                    {(this.state.mobileMenu) ? Body.getMenu('pull-left', Assets.menuRight) : Body.getMenu('pull-right', Assets.menuRight)}
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <main className="main">
                    <div className="container">
                        <div className="panel panel-default two-column equal-height-wrapper">
                            <div className="panel-left equal-height-col">
                                <div className="form form-signup">
                                    <div className="h3">
                                        Sign Up
                                    <span className="text-right text-small">&Prime;All fields are mandatory&Prime;</span>
                                    </div>
                                    <div className="clearfix" />
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className={(registration.registration && (registration.registration.message === 'Email already exists.' || registration.registration.message === 'Both already exist.')) ? 'form-group has-error' : 'form-group'}>
                                                    <span>Email</span>
                                                    <input type="email" className="form-control" placeholder="" value={this.state.email} onChange={(event) => this.handleInput(event.target.value, 'email')} />
                                                    <span className="error-block"><span>Email already exists</span></span>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className={(registration.registration && (registration.registration.message === 'Username already exists.' || registration.registration.message === 'Both already exist.')) ? 'form-group has-error' : 'form-group'}>
                                                    <span>Username</span>
                                                    <input type="text" className="form-control" placeholder="" value={this.state.username} onChange={(event) => this.handleInput(event.target.value, 'username')} />
                                                    <span className="error-block"><span>Username already exists</span></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="form-group">
                                                    <span>Password</span>
                                                    <input type="password" className="form-control" placeholder="" value={this.state.password} onChange={(event) => this.handleInput(event.target.value, 'password')} />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className={(this.state.password === this.state.passwordConfirmation) ? 'form-group' : 'form-group has-error'}>
                                                    <span>Confirm Password</span>
                                                    <input type="password" className="form-control" placeholder="" value={this.state.passwordConfirmation} onChange={(event) => this.handleInput(event.target.value, 'passwordConfirmation')} />
                                                    <span className="error-block"><span>Passwords do not match</span></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="checkbox-wrapper">
                                                <input type="checkbox" checked={this.state.checkbox} onClick={() => this.setState({ checkbox: !this.state.checkbox })} />
                                                <span className="checkbox-span" />I Agree to the Accumulator Club
                                                <Link to="/termsandconditions" className="btn-link"> Terms of Service </Link>
                                                and 
                                                <Link to="/privacypolicy" className="btn-link"> Privacy Policy. </Link>
                                                I also confirm that I am at least 18 years of age.
                                            </label>
                                            <span className="error-block"><span>Error message</span></span>
                                        </div>
                                        <div className="form-group">
                                            <label className="checkbox-wrapper">
                                                <input type="checkbox" checked={this.state.subscription} onClick={() => this.setState({ subscription: !this.state.subscription })} />
                                                <span className="checkbox-span"/>
                                                I would like to receive game updates, reminders and tips from The Accumulator Club (once a week).
                                            </label>
                                        </div>
                                        <div className="form-group">
                                            <button className="btn btn-lg btn-block btn-primary no-shadow">SIGNUP</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="panel-right display-table equal-height-col">
                                <div className="h3">
                                    Get involved! Sign up here...
                            </div>
                                <p>Create your account and become a valued member of The Accumulator Club by completing the fields to the left. You will receive an email to validate your account and then you can enjoy this gaming revolution!
                                    <br />
                                    <br />
                                    Thank you for joining The Accumulator Club.
                                </p>
                                <div className="table-row">
                                    <div className="vertical-bot">
                                        Already a member? <Link to="/login" className="btn-link">Login here</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(registration.registration && registration.registration.message === 'Registration successful.') ? this.showPopup() : null}
                </main>
            </section>
        )
    }

    showPopup(): JSX.Element {
        const screenPosition = document.documentElement.scrollTop + 150
        const top = screenPosition.toString() + 'px'
        return (
            <div className="popup">
                <div className="popup-inner popup-forgot" style={{ top }}>
                    <div style={{ textAlign: 'right', marginBottom: '10px' }}>
                        <img onClick={() => {Socket.Set('registration', {}), this.setState(this.getInitialState())}} style={{ cursor: 'pointer' }} src="cancel-black.png" />
                    </div>
                    <div className="fist-bump"><img src="fist-bump.svg"/></div>
                    <p className="congratulations-first">Well played!</p>
                    <p className="congratulations-second">Your sign up has been received...</p>
                    <p className="congratulations-third">Please check your email inbox (and perhaps your spam) - We have sent you an email with a link to verify your email address.</p>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Views/Main/Index/SignUp.tsx